import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const EmptyState = ({ onResetFilters }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      <div className="w-20 h-20 md:w-24 md:h-24 rounded-full bg-muted flex items-center justify-center mb-6">
        <Icon name="Mail" size={40} className="text-muted-foreground" />
      </div>
      
      <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3 text-center">
        No Templates Found
      </h3>
      
      <p className="text-sm md:text-base text-muted-foreground text-center max-w-md mb-6">
        We couldn't find any email templates matching your current filters. Try adjusting your search criteria or reset filters to view all templates.
      </p>
      
      <Button
        variant="outline"
        onClick={onResetFilters}
        iconName="RotateCcw"
        iconPosition="left"
      >
        Reset Filters
      </Button>
    </div>
  );
};

export default EmptyState;